import React, { createContext, useState } from 'react'

// QuotesContext context
interface QuotesContextType {
  // Filter
  showFilter: boolean
  setShowFilter: React.Dispatch<React.SetStateAction<boolean>>

  // is calculated
  calculationState: {
    isCalculated: boolean
    isCalculating: boolean
  }
  setCalculationState: React.Dispatch<
    React.SetStateAction<{
      isCalculated: boolean
      isCalculating: boolean
    }>
  >
  onCalculationStateChange?: ({
    isCalculated,
    isCalculating,
  }: {
    isCalculated: boolean
    isCalculating: boolean
  }) => void

  // Enablde GAP
  enableGap: boolean
  setEnableGap: React.Dispatch<React.SetStateAction<boolean>>
}

const defaultState = {
  // Filter
  showFilter: false,
  setShowFilter: () => { },

  // is calculated
  calculationState: {
    isCalculated: false,
    isCalculating: false,
  },
  setCalculationState: () => { },
  onCalculationStateChange: () => { },

  // Enablde GAP
  enableGap: false,
  setEnableGap: () => { },
}

export const QuotesContext = createContext<QuotesContextType>(
  defaultState as QuotesContextType,
)

// QuotesProvider component
export interface QuotesProviderProps extends React.PropsWithChildren {
  onCalculationStateChange?: ({
    isCalculated,
    isCalculating,
  }: {
    isCalculated: boolean
    isCalculating: boolean
  }) => void
}

export const QuotesProvider = (props: QuotesProviderProps) => {
  const { children, onCalculationStateChange } = props
  const [showFilter, setShowFilter] = useState(false)
  const [calculationState, setCalculationState] = useState<{
    isCalculated: boolean
    isCalculating: boolean
  }>({ isCalculated: false, isCalculating: false })
  const [enableGap, setEnableGap] = useState(false)

  return (
    <QuotesContext.Provider
      value={{
        // Filter
        showFilter,
        setShowFilter,

        // is calculated
        calculationState,
        setCalculationState,
        onCalculationStateChange,

        // Enablde GAP
        enableGap,
        setEnableGap,
      }}
    >
      {children}
    </QuotesContext.Provider>
  )
}

// useQuotes hook
export interface useQuotesReturn {
  // Filter
  showFilter: boolean
  setShowFilter: React.Dispatch<React.SetStateAction<boolean>>

  // is calculated
  calculationState: {
    isCalculated: boolean
    isCalculating: boolean
  }
  setCalculationState: React.Dispatch<
    React.SetStateAction<{
      isCalculated: boolean
      isCalculating: boolean
    }>
  >
  onCalculationStateChange?: ({
    isCalculated,
    isCalculating,
  }: {
    isCalculated: boolean
    isCalculating: boolean
  }) => void

  // Enablde GAP
  enableGap: boolean
  setEnableGap: React.Dispatch<React.SetStateAction<boolean>>
}

export const useQuotes = (): useQuotesReturn => {
  const context = React.useContext(QuotesContext)

  if (!context || context === undefined) {
    throw new Error('useQuotes must be used within a QuotesProvider')
  }

  return {
    // Filter
    showFilter: context.showFilter,
    setShowFilter: context.setShowFilter,

    // is calculated
    calculationState: context.calculationState,
    setCalculationState: context.setCalculationState,
    onCalculationStateChange: context.onCalculationStateChange,

    // Enablde GAP
    enableGap: context.enableGap,
    setEnableGap: context.setEnableGap,
  }
}
